import { Radio, RadioGroup, Stack } from '@chakra-ui/react';
import React from 'react';

import type { TapeBuilderMode } from './GraphContext';

type ModeProps = {
  mode: TapeBuilderMode;
  setMode: (mode: TapeBuilderMode) => void;
};
export const TapeBuilderModeSelect = ({ setMode, mode }: ModeProps) => {
  return (
    <RadioGroup onChange={setMode} value={mode} ml="10px">
      <Stack direction="row">
        <Radio value="Edit">Edit</Radio>
        <Radio value="QA">QA</Radio>
        <Radio value="Monitor">Monitor</Radio>
        <Radio value="View">View</Radio>
      </Stack>
    </RadioGroup>
  );
};
